<template>
    <div>
        <SettingsCardTitle>
            {{ __('general.contact_info') }}
            <template v-slot:subtitle>
                {{ __('actions.manage_emails_in_one_place') }}
            </template>
        </SettingsCardTitle>

        <FormGroupNew :label="__('sale.customer_support_requests')"
                      :description="__('sale.customer_support_email_description')"
                      :error="form.errors.sales_contact_email"
                      required
        >
            <input type="email" class="form-control" v-model="form.sales_contact_email">
        </FormGroupNew>

        <FormGroupNew :label="__('general.reservations')"
                      :description="__('reservations.contact_description')"
                      :error="form.errors.reservations_contact_email"
                      required
        >
            <input type="email" class="form-control" v-model="form.reservations_contact_email">
        </FormGroupNew>

        <FormGroupNew :label="__('sale.invoices')"
                      :description="__('email.for_invoice_description')"
                      :error="form.errors.invoice_contact_email"
                      required
        >
            <input type="email" class="form-control" :placeholder="form.sales_contact_email"
                   v-model="form.invoice_contact_email">
        </FormGroupNew>

        <DividerDotted class="mb-3"/>
        <SaveAndEnableButton :for="form" @click="save"/>
    </div>
</template>

<script>
import Navigation from "@pages/Stores/Edit/Nav/Navigation.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import SaveAndEnableButton from "@components/Integrations/SaveAndEnableButton.vue";
import SettingsCardTitle from "@components/Form/SettingsCardTitle.vue";
import DividerDotted from "@components/Form/DividerDotted.vue";

export default {
    layout: Navigation,

    components: {DividerDotted, SettingsCardTitle, SaveAndEnableButton, FormGroupNew},

    props: {
        store: Object,
        salesContactEmail: String,
        invoiceContactEmail: String,
        reservationsContactEmail: String,
    },

    data() {
        return {
            form: this.$inertia.form({
                sales_contact_email: this.salesContactEmail,
                invoice_contact_email: this.invoiceContactEmail,
                reservations_contact_email: this.reservationsContactEmail,
            })
        }
    },

    methods: {
        save() {
            this.form.patch(this.$route('store.edit.contact.update', [this.store.id]));
        }
    }
}
</script>
